import { useState } from 'react';

/**
 * The same object for as long as its content does not change, so that an
 * effect keyed on it runs once per content. A `useMemo` keyed on the content
 * does not do this: the React Compiler replaces its dependencies with the
 * ones it infers, and the object then changes with every new reference.
 */
export function useByContent<T>(value: T): T {
  const key = JSON.stringify(value) ?? '';
  const [held, setHeld] = useState({ key, value });
  if (held.key !== key) {
    // Storing what changed during render: React renders again at once.
    setHeld({ key, value });
    return value;
  }
  return held.value;
}
